import { Button, TextField, Box, Typography } from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { useLoaderData, useNavigate } from 'react-router'
import { SubscriptionModel } from 'types'

export default function SubscriptionPreviewPage() {
  const navigate = useNavigate()
  const sub = useLoaderData() as SubscriptionModel

  return (
    <PageAppBar pageName={`Abonnement: ${sub.name}`}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          alignItems: 'center',
          padding: '2rem',
        }}
      >
        <Typography variant="h4">{sub.name}</Typography>
        <Box sx={{ display: 'flex', gap: '1rem' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(`/subscription/${sub.id}/edit`)}
          >
            Modifier
          </Button>
        </Box>
        <TextField
          fullWidth
          label="ID"
          value={sub.id}
          variant="outlined"
          InputProps={{ readOnly: true }}
        />
        <TextField
          fullWidth
          label="Prix"
          value={sub.price}
          variant="outlined"
          InputProps={{ readOnly: true }}
        />
        <TextField
          fullWidth
          label="Nombre max de profils"
          value={sub.maxProfiles}
          variant="outlined"
          InputProps={{ readOnly: true }}
        />
        <TextField
          fullWidth
          label="Nombre max de licences"
          value={sub.maxLicenses}
          variant="outlined"
          InputProps={{ readOnly: true }}
        />
        <TextField
          fullWidth
          label="Nombre d'abonnés actifs"
          value={sub.nbOfSubscribers || 0}
          variant="outlined"
          InputProps={{ readOnly: true }}
        />
      </Box>
    </PageAppBar>
  )
}
